
@if (anchors) {
  <ul>
    @for (item of anchors; track item) {
      <li [ngClass]="{'is-active' : item.isActive}">
        <a [fragment]="item.id" [routerLink]="[]" href="">{{item.titre}}</a>
      </li>
    }
  </ul>
}
<ng-content></ng-content>
